export enum RoutePaths {
  Login = "/innlogging",
  Quiz = "/quiz",
  Scoreboard = "/poengliste",
  Activities = "/aktiviteter",
  Dua = "/dua",
  Users = "/brukere",
  Statistics = "/statistikk",
  Root = "/",
  NotFound = "*",
}
